module.exports = __webpack_public_path__ + "static/media/3h.cd72d55a.png";